import { FETCH_BUBBLES, UPDATE_BUBBLES } from "../actions/types";
import { FETCH_SETTINGS } from "../actions/types";
import _ from "lodash";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_BUBBLES:
      return {
        ...state,
        bubbles: action.payload
      };
    case UPDATE_BUBBLES:
      return {
        ...state,
        updateResponse: action.payload
      };
    case FETCH_SETTINGS:
      return {
        ...state,
        config: action.payload
      };
    default:
      return state;
  }
}
